import NetworkService from '../services/network.service'


class LoginApi {
    login = async (params: any) => {

        let url = `api/login`;
        let data = await NetworkService.post(url, params)
        return data && data.data
            ? data.data : data

    };

    getLoginState() {
        return !!localStorage.getItem('access-token');
    }

    logout() {
        try{
		let user = localStorage.getItem("email");
		let accessToken = localStorage.getItem("access-token");
		return NetworkService.post(`api/logout`, {
			accessToken,
		});
    } catch(error) {
       throw new Error('An error occured');
    }
	}
    auth = async ()=>{
        let url = 'api/common/auth'; 
        const googleTokenId = localStorage.getItem("access-token");
        const params = {
            googleTokenId : googleTokenId,
        }
        let data = await NetworkService.post(url, params)
        return data && data.data
            ? data.data : data
    }  
}
export default LoginApi;